'use client';

import { PlantCard } from '@/components/ui';
import { updatePlantOrderMutation } from '@/lib/apollo/mutations';
import { usePlants } from '@/lib/store';
import { useMutation } from '@apollo/client';
import { DndContext, closestCenter } from '@dnd-kit/core';
import { SortableContext, arrayMove, rectSortingStrategy } from '@dnd-kit/sortable';
import { Center, SimpleGrid, Text } from '@mantine/core';
import _ from 'lodash';
import { useSession } from 'next-auth/react';
import { redirect } from 'next/navigation';
import { useEffect, useState } from 'react';

// Override console.error
// This is a hack to suppress the warning about missing defaultProps in the recharts library
// @link https://github.com/recharts/recharts/issues/3615
const error = console.error;
console.error = (...args) => {
    if (/defaultProps/.test(args[0])) return;
    error(...args);
};

const IndexPage = () => {
    const { data: session } = useSession({
        required: true,
        onUnauthenticated: () => redirect('/login'),
    });

    const { plants: tempPlants, plantOrder, setPlantOrder } = usePlants();

    const [plants, setPlants] = useState([]);
    const [updatePlantOrder] = useMutation(updatePlantOrderMutation);

    useEffect(
        () => setPlants(_.cloneDeep(tempPlants).sort((a, b) => plantOrder.indexOf(a.id) - plantOrder.indexOf(b.id))),
        [tempPlants, plantOrder]
    );

    const handleDragEnd = (event) => {
        const { active, over } = event;
        if (active.id !== over?.id) {
            const order = arrayMove(plantOrder, plantOrder.indexOf(active.id), plantOrder.indexOf(over.id));
            setPlantOrder(order);
            updatePlantOrder({ variables: { email: session.data.email, order } });
        }
    };

    return plants.length > 0 ? (
        <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
            <SortableContext items={plants} strategy={rectSortingStrategy}>
                <SimpleGrid cols={{ base: 2, sm: 3, md: 4, lg: 5 }}>
                    {plants.map((plant) => (
                        <PlantCard key={plant.id} plant={plant} />
                    ))}
                </SimpleGrid>
            </SortableContext>
        </DndContext>
    ) : (
        <Center>
            <Text fz="lg" c="dimmed">
                Nessun impianto disponibile. Aggiunti un impianto da Spark per proseguire.
            </Text>
        </Center>
    );
};
export default IndexPage;
